import { render } from "./DetailCourse.vue?vue&type=template&id=580306fc"
import script from "./DetailCourse.vue?vue&type=script&lang=js"
export * from "./DetailCourse.vue?vue&type=script&lang=js"

import "./DetailCourse.vue?vue&type=style&index=0&id=580306fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__